/*
 * @Author: NIXY
 * @LastEditors: NIXY
 * @Date: 2022-03-25 16:52:41
 * @LastEditTime: 2022-06-20 15:12:17
 * @Description: 地图方法统一入口
 * @FilePath: \dld-qbj\src\scopes\project\common\utils\gis\uniteApi\map-public-method.js
 */
// import tdtMethod from './tdt-method'
import gdMethod from './gd-method'
export default {
  map: null, // 地图对象
  mapType: 'gd', // 地图种类 tdt: 天地图  gd: 高德地图  bd：百度地图
  defaultLayers: ['area', 'sonArea'], // 天地图默认layers
  attributes: { // 地图自有属性 记录地图初始化属性 （天地图： 图层等。缩放级别，中心点 等）
    layers: {}, // 地图图层索引
  },
  /**
   * 添加地图
   * @param {String} mapType 地图类型
   *    tdt: 天地图类型
   *    gd: 高德地图类型
   *    bd：百度地图类型
   * @param {String} domId： 地图容器id
   * @param {String} baseMapType：地图加载底图类型
   *   天地图字段格式为：
   *           底图提供商加横线连接地图类型（矢量，影像） eg: tdt-yx :标识天地图影像  tdt-sl:标识天地图矢量
   *   高德底图字段格式为：
   *           矢量地图： 不需要传参
   *           影像底图： yx
   *           道路底图： lw
   *           影像叠路网： yxlw
   * @param {Object} option: 地图初始化相关配置  具体配置内容参考具体地图api  主要用于高德等地图的个性化配置
   */
  loadMap (mapType, domId, baseMapType, option = {}) {
    this.mapType = mapType // 设置地图种类
    switch (this.mapType) {
      case 'tdt':
        this.map = tdtMethod.loadMap(domId, baseMapType)

        break
      case 'gd':
        this.map = gdMethod.loadMap(domId, baseMapType, option)
        break
      case 'bd':
        break
    }
    return this.map
  },
  /**
   * 添加掩模地图
   * @param {String} mapType 地图类型
   *    tdt: 天地图类型
   *    gd: 高德地图类型
   * @param {String} domId： 地图容器id
   * @param {String} baseMapType：地图加载底图类型
   *   高德底图字段格式为：
   *           矢量地图： 不需要传参
   *           影像底图： yx
   *           道路底图： lw
   *           影像叠路网： yxlw
   * @param {Object} option: 地图初始化相关配置  具体配置内容参考具体地图api  主要用于高德等地图的个性化配置
   * @param {Array} sets 地图掩模型 经纬度范围 eg[[[经度，纬度],[经度，纬度]]]
   */
  loadMeshMap (mapType, domId, baseMapType, option = {}, sets) {
    this.mapType = mapType // 设置地图种类
    switch (this.mapType) {
      case 'tdt':

        break
      case 'gd':
        this.map = gdMethod.loadMeshMap(domId, baseMapType, option, sets)
        break
      case 'bd':
        break
    }
    return this.map
  },

  /**
   * 地图属性初始化
   * @param {array} layers 地图图层数组
   * 天地图初始化的时候需要 声明图层
   */
  initLayers (layers) {
    switch (this.mapType) {
      case 'tdt': // 天地图初始化图层信息等
        tdtMethod.addLayers([...this.defaultLayers, ...(layers || [])]) // 添加图层 返回图层键值对
        break
      case 'gd': // 高德地图初始化（暂无）
        break
      case 'bd': // 百度地图初始化（暂无）
        break
    }
  },
  /**
   * 添加点位
   * @param {String} layerCode 点位类型
   * @param {Object} info
   *        longitude: 经度 latitude:纬度
   *        layerCode: 点位类型编码
   *        tdt: layerCode: 必传
   * @param {Object} callBack
   *    clickCallBack 鼠标点击事件回调
   *    mousemoveCallBack 鼠标悬浮事件回调
   *    mouseoutCallBack 鼠标移除事件回调
   *  @param {Object} option 点位样式配置
   *        anchor: 布局方式(默认 bottom-center)
   *        offset: 定位布局偏移（Array） [0,0] 表示不偏移
   *        clickable： 点位是否可以点击(高德专有)
   */
  addOverlay (layerCode, info, callBack, option) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.addOverlay(layerCode, info, callBack, option)
        break
      case 'gd':
        gdMethod.addMarker(layerCode, info, callBack, option)
        break
      case 'bd':
        break
    }
  },
  /**
   * 添加自定义传入html的信息体
   * @param {String}
   * @param {Object} info
   *        longitude: 经度 latitude:纬度
   *        layerCode: 点位类型编码 必传
   * @param {String} domStr 自定传入的dom string
   * @param {Object} callBack
   *   clickCallBack 点位点击事件回调
   *   mousemoveCallBack 点位鼠标悬浮事件回调
   *   mouseoutCallBack 点位鼠标移出事件回调
   @param {Object} option 点位样式配置
   *        anchor: 布局方式(默认 bottom-center)
   *        offset: 定位布局偏移（Array） [0,0] 表示不偏移
   *        clickable： 点位是否可以点击(高德专有)
   */
  addCustomOverlay (layerCode, info, domStr, callBack, option) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.addCustomOverlay(layerCode, info, domStr, callBack, option)
        break
      case 'gd':
        gdMethod.addCustomInfo(layerCode, info, domStr, callBack, option)
        break
      case 'bd':
        break
    }
  },
  /**
   *
   * @param {String} layerCode 图层类型
   * @param {Array} pointArr 点位集合
   *       eg: [{longitude:104,latitude:30},]
   * @param {Object} option 线对象配置
   *        ifMove: 是否自动动画回放(--天地图专用)
   *        ifFixed: 是否将线条置于视图中央
    *      showDir: 是否显示箭头(--高德图专用)
   *     dirColor: 箭头颜色(--高德图专用)
   *  strokeColor: 线条颜色
   * strokeWidth: 线宽
   *   ifFixed: 是否将视图聚焦到当前线段
   */
  addLine (layerCode, pointArr, option) {
    switch (this.mapType) {
      case 'tdt':
        return tdtMethod.addLine(layerCode, pointArr, option)
        break
      case 'gd':
        return gdMethod.addLine(layerCode, pointArr, option)
        break
      case 'bd':
        return null
        break
    }
  },
  /**
   * 添加热力图
   * @param {Array} data 热力图数据集合
   *   item:
   *      longitude: '经度'
   *      lattitude: '纬度'
   *      count：权重 --非必传(高德专用  建议不传)
   * @param {Object} option 热力图配置选项
   *  天地图：
   *     radius：热力图半径
   *       blur：热力图blur
   *  高德：
   *      radius: 热力图半径
   *     opacity: 热力图透明度范围（高德专用）
   */
  addHeatMap (data, option) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.addHeatMap(data, option)
        break
      case 'gd':
        gdMethod.addHeatMap(data, option)
        break
      case 'bd':
        break
    }
  },
  /**
   * 清除点位热力图
   */
  removeHeatMap () {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.removeHeatMap()
        break
      case 'gd':
        gdMethod.hideHeatMap()
        break
      case 'bd':
        break
    }
  },
  /**
   * 添加当前区域范围
   * @param {Object} areaInfo: 外层区域信息  包含区域的名称  编码  经纬度数据
   *   sets: {Array} 经纬度数据   eg：[[经度，纬度],[经度，纬度]]
   * @param {Object} option: 几何图形样式配置
   *  strokeColor: 线条颜色
   *  strokeWidth: 线条宽度
   *      lineDash: 线条虚线程度 eg lineDash:[5]
   *    fillColor: 区域填充颜色
   *     ifFit 是否将视图聚焦到改区域
   *        strokeOpacity： 线透明度 (--高德专有)
   *        fillColor：填充色
   *        fillOpacity：填充透明度 （高德专有）
   *        zIndex: 所处层级 （高德专有 默认10）
   * @param {Object} callBack
   *   clickCallBack 点位点击事件回调
   *   mousemoveCallBack 点位鼠标悬浮事件回调
   *   mouseoutCallBack 点位鼠标移出事件回调
   */
  addPolygon (layerCode, areaInfo, option = {}, callBack) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.addPolygon(layerCode, areaInfo, option, callBack)
        break
      case 'gd':
        gdMethod.addPolygon(layerCode, areaInfo, option, callBack)
        break
      case 'bd':
        break
    }
  },
  /**
   * 添加区域色块
   * @param {Object} areaList: 区域信息数组
   * @param {Object} 区域绘制属性配置
   * 天地图：
   *    strokeColor: 线条颜色
   *    fillColor: 填充颜色
   *    strokeWidth： 线宽
   *  @param {Object} callBack
   *   clickCallBack 点位点击事件回调
   *   mousemoveCallBack 点位鼠标悬浮事件回调
   *   mouseoutCallBack 点位鼠标移出事件回调
   */
  addSmallArea (areaList, callBack) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.addSonArea(areaList, callBack)
        break
      case 'gd':
        gdMethod.addSonArea(areaList, callBack)
        break
      case 'bd':
        break
    }
  },
  /**
   * 删除地图点位
   * @param {*} layerCode 
   */
  async removeMarkers (layerCode) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.removeOverlays(layerCode)
        break
      case 'gd':
        await gdMethod.removeElements(layerCode)
        break
      case 'bd':
        break
    }
  },
  /**
   * 删除地图某一个点位
   * @param {String} layerCode 图层
   * @param {String} attributeName 点位属性名称
   * @param {String} value 点位属性值
   */
  async removeOneMarkers (layerCode,attributeName,value) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.removeOneOverlays(layerCode,attributeName,value)
        break
      case 'gd':
        await gdMethod.removeOneElements(layerCode,attributeName,value)
        break
      case 'bd':
        break
    }
  },
  /**
   * 底图清除一类地图元素(区域、结合图层等、等等)
   * @param {String} layer:  指代一种图层类型   bd&gd： 指代待清除对象的索引
   */
  async removeLayer (layer) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.removeLayer(layer) // 清空整个图层
        break
      case 'gd':
        await gdMethod.removeLayer(layer)
        break
      case 'bd':
        break
    }
  },
  /**
   * 设置地图中心点
   * @param {String/Number} lon 经度
   * @param {String/Number} lat  纬度
   * @param {String/Number} zoom 缩放比例
   */
  setCenter (lon, lat, zoom) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.setCenter(lon, lat, zoom)
        break
      case 'gd':
        gdMethod.setCenter(lon, lat, zoom)
        break
      case 'bd':
        break
    }
  },
  /**
   * 添加一个椭圆
   * @param {String} layerCode 椭圆图层
   * @param {Object} info 基本信息
   *    longitude: 经度（必填）
   *    latitude: 纬度（必填）
   *       radius: 半径（必填  数字）
   * @param {Object} option 椭圆配置样式
   * strokeColor:  线颜色
   *    strokeOpacity: 线透明度
   *   strokeWeight:  线粗细度
   *  fillColor: 填充颜色
   * fillOpacity: 填充透明度
   *  zIndex: 元素层级（默认10  现在默认20）
   * @param {Object} callBack 回调
   *      clickCallBack 地图元素点击事件回调
   *      mousemoveCallBack 地图元素鼠标悬浮事件回调
   *      mouseoutCallBack 地图元素鼠标移除事件回调
   */
  addCircle (layerCode, info, option, callBack) {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.addCircle(layerCode, info, option, callBack)
        break
      case 'gd':
        gdMethod.addCircle(layerCode, info, option, callBack)
        break
      case 'bd':
        break
    }
  },
  /**
   *
   * @param {String} type 绘制类型
   * @param {Object} option 绘制配置 具体看各个地图的api
   */
  drawElements (type = 'circle', option,callBack) {
    if (option.strokeWeight) {
      option.strokeWidth = option.strokeWeight
    }
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.drawElementsCustom(type, option,callBack)
        break
      case 'gd':
        gdMethod.drawElementsCustom(type, option,callBack)
        break
      case 'bd':
        break
    }
  },
  /**
   * 绘制地图圆形对象
   * @param {Object} option 对象样式配置
   * fillColor: 填充颜色
   * strokeColor: 边线颜色
   * fillOpacity: 填充色透明度
   * strokeWidth: 边线宽度
   */
  drawCircle (option = { fillColor: 'rgba(255,0,0,0.2)', strokeColor: 'rgba(255,0,0,0.1)', },callBack) {
    switch (this.mapType) {
      case 'tdt':
        this.drawElements('Circle', option,callBack)
        break
      case 'gd':
        this.drawElements('circle', option,callBack)
        break
      case 'bd':
        break
    }
  },
  /**
   * 关闭圆形区域绘制功能
   */
  closeDrawCircle () {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.drawElementsClose()
        break
      case 'gd':
        gdMethod.drawElementsClose()
        break
      case 'bd':
        break
    }
  },
  /**
   * 删除绘制的圆形
   */
  removeDrawCircleElement () {
    switch (this.mapType) {
      case 'tdt':
        tdtMethod.removeLayer('draw')
        break
      case 'gd':
        gdMethod.removeElements('drawcircle')
        break
      case 'bd':
        break
    }
  },
  /**
   * 获取所有的地图上的元素类型
   */
  getAllLayerCode () {
    let obj = {}
    switch (this.mapType) {
      case 'tdt':
        obj = tdtMethod.getAllLayerCode()
        break
      case 'gd':
        obj = gdMethod.getAllLayerCode()
        break
      case 'bd':
        break
    }
    return obj
  },
  /**
   * 获取区域中心
   * points： 区域线点位集合
   */
  getCenterOfArea (points) { 
    let center = null
    switch (this.mapType) {
      case 'tdt':
        center = tdtMethod.getCenterOfArea(points)
        break
      case 'gd':
        center = gdMethod.getCenterOfArea(points)
        break
      case 'bd':
        break
    }
    return center
  }
}



// WEBPACK FOOTER //
// ./src/utils/uniteApi/map-public-method.js